// 后台请求返回码值
export const REQUEST_CODE = {
  SUCCESS: 200,
  CLIENT_ERROR: 400,
  ERROR: 500,
  SERVICE_ERROR: 600,
  NO_LOGIN: 601,
  NO_AUTH: 602,
  ONLY_WH_CHAT: 603,
  PARAMS_ERROR: 604
}
